import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
export var calculateTotalMinutes = function calculateTotalMinutes(hour, minute) {
  return hour * 60 + minute;
};

/**
 * Converts a 24h hour string to a display-friendly hour + suffix.
 * Used by the **select variant** to render each option label.
 *
 * Examples (a.m/p.m mode):
 *   "00" → { hourStr: "12", suffix: " a.m" }  (midnight displays as 12 a.m)
 *   "13" → { hourStr: "01", suffix: " p.m" }
 *   "12" → { hourStr: "12", suffix: " p.m" }  (noon stays 12, flips to p.m)
 *
 * In 24hour mode the hour is returned as-is with no suffix.
 */
export var getHourData = function getHourData(hour, mode) {
  var h = parseInt(hour);
  if (mode === 'a.m/p.m') {
    var isPm = h >= 12;
    var suffix = isPm ? ' p.m' : ' a.m';
    // Modulo 12 converts 13→1, 14→2, etc. The `|| 12` handles midnight (0%12=0→12)
    // and noon (12%12=0→12) — both display as "12" in 12-hour format.
    var converted = h % 12 || 12;
    return {
      hourStr: ('0' + converted).slice(-2),
      suffix: suffix
    };
  }
  return {
    hourStr: hour,
    suffix: ''
  };
};

/**
 * Generates zero-padded minute strings from 0 up to 59, stepping by `interval`.
 * E.g. interval=15 → ["00", "15", "30", "45"]
 */
export var generateMinuteArray = function generateMinuteArray(interval) {
  var minutes = [];
  for (var m = 0; m < 60; m += interval) {
    // Zero-pad: prepend "0" then take last 2 chars → "0"→"00", "5"→"05", "15"→"15"
    minutes.push(('0' + m).slice(-2));
  }
  return minutes;
};

/**
 * Parses a 24h `"HH:mm"` time string into hour and minute numbers.
 * Returns undefined for empty, malformed, or non-numeric input — callers
 * should handle the undefined case as "no value selected".
 */
export var parseTimeValue = function parseTimeValue(value) {
  if (!value) {
    return undefined;
  }
  var _value$trim$split = value.trim().split(':'),
    _value$trim$split2 = _slicedToArray(_value$trim$split, 2),
    hourStr = _value$trim$split2[0],
    minuteStr = _value$trim$split2[1];
  if (!hourStr || !minuteStr) {
    return undefined;
  }
  var hour = parseInt(hourStr);
  var minute = parseInt(minuteStr);
  if (isNaN(hour) || isNaN(minute)) {
    return undefined;
  }
  return {
    hour: hour,
    minute: minute
  };
};

/**
 * Formats a 24h `"HH:mm"` value into a user-facing display string.
 * This is the single source of truth for how times appear in the trigger button.
 *
 * - a.m/p.m mode: "21:30" → "09:30 p.m", "00:00" → "12:00 a.m"
 * - 24hour mode: returns the value unchanged ("21:30" → "21:30")
 */
export var formatTimeDisplay = function formatTimeDisplay(value, mode) {
  var parsed = parseTimeValue(value);
  if (!parsed) {
    return value;
  }
  if (mode === 'a.m/p.m') {
    var h12 = parsed.hour % 12 || 12;
    var suffix = parsed.hour >= 12 ? 'p.m' : 'a.m';
    return "".concat(('0' + h12).slice(-2), ":").concat(('0' + parsed.minute).slice(-2), " ").concat(suffix);
  }
  return value;
};